import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { createContext, use } from "react";

interface ProductCartContextModel {
    cart: Cart | undefined | null;
    allowInstantAddToCart: boolean;
}

const defaultContext: ProductCartContextModel = {
    allowInstantAddToCart: false,
    cart: undefined
};

export const ProductCartContext =
    createContext<ProductCartContextModel>(defaultContext);

export const useProductCartContext = (): ProductCartContextModel => {
    const context = use<ProductCartContextModel>(ProductCartContext);
    if (context === undefined) {
        throw new Error("ProductCartContext is undefined.");
    }
    return context;
};
